import React, { Suspense, lazy } from 'react';

// Immediate load - critical above the fold
import BannerSection from '../../components/BannerSection';

// Lazy load - progressive loading
const AboutUsSection = lazy(() => import("../../components/AboutUsSection"));
const AddSection = lazy(() => import("../../components/AddSection"));
const CompetitionSection = lazy(() => import("../../components/CompetitionSection"));
const Service = lazy(() => import("../../components/ui/OurServices"));
const ProccessFlow = lazy(() => import("../../components/ui/ProcessFlow"));
const WhyChooseUs = lazy(() => import("../../components/ui/WhyChooseUs"));
const Testimonials = lazy(() => import('../../components/ui/Testimonials'));
const Network = lazy(() => import('../../components/ui/Network'));

// Loading component
const SectionLoader = () => (
  <div className="w-full h-32 flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

const Home = () => {
  return (
    <>
      {/* Immediate load - above the fold */}
      <BannerSection />

      {/* Progressive loading with Suspense */}
      <Suspense fallback={<SectionLoader />}>
        <AboutUsSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <AddSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <Service />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <ProccessFlow />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <CompetitionSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <WhyChooseUs />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <Testimonials />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <Network />
      </Suspense>
    </>
  );
};

export default Home;
